import { API_ORIGIN } from '../../api/client';

const API_URL = `${API_ORIGIN}/api`;

async function handleResponse(res) {
  if (!res.ok) {
    let message = `Request failed (${res.status})`;
    try {
      const data = await res.json();
      message = data.message || message;
    } catch {
      // response wasn't JSON, keep the default message
    }
    throw new Error(message);
  }
  return res.json();
}

function authHeaders(token) {
  return { Authorization: `Bearer ${token}` };
}

export async function adminLogin(username, password) {
  const res = await fetch(`${API_URL}/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, password }),
  });
  return handleResponse(res);
}

// ---- Hero slides ----
// Note: there's no GET /api/hero/:id on the backend, only the list endpoints below.
export async function getAllHeroSlides(token) {
  const res = await fetch(`${API_URL}/hero/all`, { headers: authHeaders(token) });
  return handleResponse(res);
}

export async function createHeroSlide(token, formData) {
  const res = await fetch(`${API_URL}/hero`, {
    method: 'POST',
    headers: authHeaders(token), // don't set Content-Type - fetch sets the multipart boundary itself
    body: formData,
  });
  return handleResponse(res);
}

export async function updateHeroSlide(token, id, formData) {
  const res = await fetch(`${API_URL}/hero/${id}`, {
    method: 'PUT',
    headers: authHeaders(token),
    body: formData,
  });
  return handleResponse(res);
}

export async function deleteHeroSlide(token, id) {
  const res = await fetch(`${API_URL}/hero/${id}`, {
    method: 'DELETE',
    headers: authHeaders(token),
  });
  return handleResponse(res);
}

// ---- Movies ----
export async function getAllMovies(token, status) {
  const query = status ? `?status=${status}` : '';
  const res = await fetch(`${API_URL}/movies${query}`, { headers: authHeaders(token) });
  return handleResponse(res);
}

// GET /api/movies/:id is public, so no token needed here - handy for prefilling edit forms.
export async function getMovieById(id) {
  const res = await fetch(`${API_URL}/movies/${id}`);
  return handleResponse(res);
}

export async function createMovie(token, formData) {
  const res = await fetch(`${API_URL}/movies`, {
    method: 'POST',
    headers: authHeaders(token),
    body: formData,
  });
  return handleResponse(res);
}

export async function updateMovie(token, id, formData) {
  const res = await fetch(`${API_URL}/movies/${id}`, {
    method: 'PUT',
    headers: authHeaders(token),
    body: formData,
  });
  return handleResponse(res);
}

export async function deleteMovie(token, id) {
  const res = await fetch(`${API_URL}/movies/${id}`, {
    method: 'DELETE',
    headers: authHeaders(token),
  });
  return handleResponse(res);
}
